export function initialize(appInstance) {
  appInstance.lookup("service:google-picker-auth")
}

export default {
  name: "google-picker-auth",
  initialize: initialize,
}
